"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnchorTarget;
(function (AnchorTarget) {
    AnchorTarget["Self"] = "_self";
    AnchorTarget["Blank"] = "_blank";
    AnchorTarget["Parent"] = "_parent";
    AnchorTarget["Top"] = "_top";
})(AnchorTarget = exports.AnchorTarget || (exports.AnchorTarget = {}));
var ThemeColor;
(function (ThemeColor) {
    ThemeColor["Primary"] = "primary";
    ThemeColor["Secondary"] = "secondary";
    ThemeColor["Success"] = "success";
    ThemeColor["Danger"] = "danger";
    ThemeColor["Warning"] = "warning";
    ThemeColor["Info"] = "info";
    ThemeColor["Light"] = "light";
    ThemeColor["Dark"] = "dark";
})(ThemeColor = exports.ThemeColor || (exports.ThemeColor = {}));
//# sourceMappingURL=prop.types.js.map